const EllipseIcon = ({
	size = 'xSmall',
}: {
	size: 'xSmall' | 'small' | 'large'
}) => {
	const svgSize = size === 'xSmall' ? 8 : size === 'small' ? 16 : 24
	return (
		<svg
			width={svgSize}
			height={svgSize}
			viewBox={`0 0 ${svgSize} ${svgSize}`}
			fill="none"
			xmlns="http://www.w3.org/2000/svg"
		>
			<circle
				cx={svgSize / 2}
				cy={svgSize / 2}
				r={svgSize / 2}
				fill="currentColor"
			/>
		</svg>
	)
}

export default EllipseIcon
